const GTM_ALLOWED_PATH_SUFFIXES = ['', '/payment', '/pix', '/boleto', '/success'] as const;

const SLUG_EVENT_BASE_PATTERN = /^\/evento\/[^/]+/;
const ID_EVENT_BASE_PATTERN = /^\/public\/event\/[^/]+/;

type AllowedPathSuffix = (typeof GTM_ALLOWED_PATH_SUFFIXES)[number];

function getEventPathRemainder(pathname: string): AllowedPathSuffix | null {
  let basePath = '';

  if (SLUG_EVENT_BASE_PATTERN.test(pathname)) {
    const match = pathname.match(/^(\/evento\/[^/]+)/);
    basePath = match?.[1] || '';
  } else if (ID_EVENT_BASE_PATTERN.test(pathname)) {
    const match = pathname.match(/^(\/public\/event\/[^/]+)/);
    basePath = match?.[1] || '';
  } else {
    return null;
  }

  const remainder = pathname.slice(basePath.length) as AllowedPathSuffix;
  if (GTM_ALLOWED_PATH_SUFFIXES.includes(remainder)) {
    return remainder;
  }

  return null;
}

export function isGtmAllowedPath(pathname: string): boolean {
  return getEventPathRemainder(pathname) !== null;
}

export const GTM_ALLOWED_ROUTES = GTM_ALLOWED_PATH_SUFFIXES;
